import React, { createContext, ReactNode, useContext } from 'react';

import { LetterDrawer } from './LetterDrawer';
import { OpenLetterDrawerArgs } from './types';
import { useLetterDrawer, UseLetterDrawerReturn } from './useLetterDrawer';

interface LetterDrawerHandle {
  open: (args: OpenLetterDrawerArgs) => void;
  requestLetterType: UseLetterDrawerReturn['requestLetterType'];
  isOpen: boolean;
  letterType: UseLetterDrawerReturn['letterType'];
}

const LetterDrawerContext = createContext<LetterDrawerHandle | null>(null);

export interface LetterDrawerProviderProps {
  enabled: boolean;
  children: ReactNode;
}

export const LetterDrawerProvider = ({
  enabled,
  children,
}: LetterDrawerProviderProps) => {
  const drawer = useLetterDrawer();

  if (!enabled) {
    return <>{children}</>;
  }

  const value: LetterDrawerHandle = {
    open: drawer.open,
    requestLetterType: drawer.requestLetterType,
    isOpen: drawer.isOpen,
    letterType: drawer.letterType,
  };

  return (
    <LetterDrawerContext.Provider value={value}>
      {children}
      <LetterDrawer drawer={drawer} />
    </LetterDrawerContext.Provider>
  );
};

export function useLetterDrawerHandle(): LetterDrawerHandle | null {
  return useContext(LetterDrawerContext);
}
